var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    'small': !_vm.minimal,
    'tiny': _vm.minimal,
    'danger': _vm.isExceeded
  }},[_vm._v(" "+_vm._s(_vm.timeFormatted)+" "),(!_vm.minimal && _vm.isExceeded)?_c('f-icon',{attrs:{"name":"check_circle"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }